import { AbstractNotification } from '../abstract.notification'
import { NotificationType } from '../notification-type.enum'

export class AshesAndRosesLaunchEventNotification extends AbstractNotification {
	id = NotificationType.ASHES_AND_ROSES_LAUNCH_EVENT
}
